var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "94.316,0.046 0,0.046 0,20.023 94.316,81.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,68.345 0,94.362 39.71,94.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,161.73 0,187.747 39.71,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,20.023 256,0.046 161.684,0.046 161.684,81.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,187.747 256,161.73 216.29,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "161.684,174.276 161.684,256.046 256,256.046 256,236.069  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "256,94.362 256,68.345 216.29,94.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "0,236.069 0,256.046 94.316,256.046 94.316,174.276  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,236.069 256,216.105 172.232,161.73 196.98,161.73 256,200.041 256,187.747    216.29,161.73 256,161.73 256,148.256 148.211,148.256 148.211,256.046 161.684,256.046 161.684,174.276  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "0,148.256 0,161.73 39.71,161.73 0,187.747 0,206.648 69.197,161.73 93.945,161.73    0,222.712 0,236.069 94.316,174.276 94.316,256.046 107.789,256.046 107.789,148.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "107.789,0.046 94.316,0.046 94.316,81.816 0,20.023 0,41.885 80.842,94.362 56.094,94.362    0,57.95 0,68.345 39.71,94.362 0,94.362 0,107.836 107.789,107.836  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "256,107.836 256,94.362 216.29,94.362 256,68.345 256,49.203 186.432,94.362    161.684,94.362 256,33.139 256,20.023 161.684,81.816 161.684,0.046 148.211,0.046 148.211,107.836  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,148.256 256,107.836 148.211,107.836 148.211,0.046 107.789,0.046 107.789,107.836    0,107.836 0,148.256 107.789,148.256 107.789,256.046 148.211,256.046 148.211,148.256  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "69.197,161.73 0,206.648 0,222.712 93.945,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "172.232,161.73 256,216.105 256,200.041 196.98,161.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "80.842,94.362 0,41.885 0,57.95 56.094,94.362  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "186.432,94.362 256,49.203 256,33.139 161.684,94.362  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M331.911,289.65c-1.406,18.749-7.225,137.888,68.365,164.82  c75.617-26.939,69.775-146.075,68.365-164.82c-9.158,3.59-42.312,14.472-68.365-4.072  C374.223,304.118,341.075,293.243,331.911,289.65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA028"
    },
    d: "M437.418,313.686c-4.144-3.223-11.818,2.763-20.413,2.148c-7.971-0.569-17.796-8.642-30.565-5.162   c-3.528-3.249-1.82-10.8-1.82-10.8c-8.866,5.73-9.501,13.576-8.944,17.83c-6.322,8.354-5.895,21.1-4.716,24.991   c1.535,5.065,4.451,5.679,4.911,11.357c0.46,5.679,2.609,3.684,2.609,3.684c4.44-2.49,5.085-7.186,6.952-14.873   c7.212,0.921,11.927-5.54,11.927-5.54c-4.733,1.485-7.716-1.124-9.343-3.421c0.254-0.759,0.457-1.459,0.748-2.258   c5.372-14.734,31.076-10.684,33.459-6.6c4.298,7.367,9.976,10.13,9.976,10.13c0-7.68-5.679-14.427-5.679-14.427   C435.116,319.212,437.418,313.686,437.418,313.686z M375.566,345.303c-0.848,0-1.535-0.687-1.535-1.535s0.687-1.535,1.535-1.535   s1.535,0.687,1.535,1.535S376.414,345.303,375.566,345.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA028"
    },
    d: "M412.108,407.969c5.005-1.584,4.43-11.299,9.812-18.028c4.991-6.241,17.213-9.751,21.592-22.241   c4.677-1.062,9.926,4.629,9.926,4.629c0.311-10.552-5.789-15.526-9.609-17.481c-3.292-9.945-14.031-16.826-17.904-18.062   c-5.041-1.61-7.201,0.443-12.139-2.399c-4.938-2.843-4.514,0.059-4.514,0.059c-0.468,5.069,3.033,8.264,8.303,14.162   c-4.85,5.417-2.204,12.964-2.204,12.964c1.462-4.74,5.303-5.716,8.118-5.753c0.481,0.639,0.942,1.204,1.435,1.897   c9.086,12.783-8.833,31.652-13.548,31.297c-8.505-0.641-14.002,2.468-14.002,2.468c6.324,4.357,15.102,3.509,15.102,3.509   C408.864,402.938,412.108,407.969,412.108,407.969z M421.164,339.097c0.481-0.698,1.437-0.874,2.135-0.393s0.874,1.436,0.393,2.135   c-0.481,0.698-1.436,0.874-2.134,0.393C420.859,340.75,420.683,339.795,421.164,339.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA028"
    },
    d: "M344.442,339.748c-0.669,5.207,8.386,8.773,12.225,16.488c3.561,7.154,1.602,19.718,11.09,28.946   c-1.005,4.689-8.376,7.056-8.376,7.056c9.441,4.723,16.52,1.282,19.901-1.36c10.407,1.198,21.168-5.648,23.919-8.64   c3.582-3.896,2.628-6.719,7.285-10.002c4.657-3.283,1.846-4.119,1.846-4.119c-4.401-2.558-8.773-0.727-16.342,1.573   c-2.873-6.679-10.833-7.455-10.833-7.455c3.684,3.321,2.954,7.216,1.803,9.785c-0.782,0.167-1.489,0.348-2.325,0.503   c-15.419,2.863-24.996-21.333-22.69-25.46c4.16-7.445,3.653-13.74,3.653-13.74c-6.614,3.903-9.538,12.223-9.538,12.223   C350.37,338.922,344.442,339.748,344.442,339.748z M403.107,376.945c0.431,0.73,0.188,1.671-0.542,2.102   c-0.73,0.431-1.671,0.188-2.102-0.542c-0.431-0.73-0.188-1.671,0.542-2.102C401.736,375.973,402.677,376.216,403.107,376.945z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CDCE0C"
    },
    d: "M400.276,458.373l-0.604-0.209c-85.117-29.609-71.363-169.961-71.214-171.378l0.266-2.536  l2.326,1.054c0.401,0.183,39.891,17.698,68.122-3.482l1.104-0.827l1.104,0.827c28.272,21.209,67.726,3.662,68.12,3.482l2.327-1.058  l0.266,2.54c0.149,1.417,13.903,141.769-71.214,171.378L400.276,458.373z M331.911,289.65  c-1.406,18.749-7.225,137.888,68.365,164.82c75.617-26.939,69.775-146.075,68.365-164.82c-9.158,3.59-42.312,14.472-68.365-4.072  C374.223,304.118,341.075,293.243,331.911,289.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M352.868,412.221c10.324,18.723,25.397,34.407,47.408,42.249  c22.017-7.844,37.093-23.527,47.418-42.249H352.868z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.021e48b3625f1fa6a5fddf298ea29c0e.svg";
export { ForwardRef as ReactComponent };